import { render, staticRenderFns } from "./Main-comp.vue?vue&type=template&id=6b52f60e&scoped=true&"
var script = {}
import style0 from "./Main-comp.vue?vue&type=style&index=0&id=6b52f60e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b52f60e",
  null
  
)

export default component.exports